import React from 'react';
import { useTranslation } from 'react-i18next';
import Card from "../../../component/Layout/theme/card";
import { useNavigate } from "react-router-dom";


const PersonalOrder = ({ personalOrder, handleResize }) => {
    const navigator = useNavigate()
    var { t } = useTranslation()

    return (
        <>
            <Card className={handleResize} >

                <div className="bg-white w-full py-5 lg:!min-w-[350px] rounded-lg space-y-5 shadow-md">
                    <div className="space-y-4">
                        <h1 className="text-base font-bold text-center">{t("personal")}</h1>
                        <p className="text-lg font-medium text-center">
                            <span >{personalOrder && personalOrder.toLocaleString('en-US')}</span>
                            <span> {t("toman")}</span>
                        </p>
                        <p className="text-sm font-medium text-center">{t("yearly")}</p>
                    </div>

                    <div className="flex flex-col gap-3 text-base font-medium text-center">

                        <p className="">{t("visits_per_year_360")}
                        </p>

                        <hr className="" />
                        <p className="" >
                            {t("create_an_image")}
                        </p>

                        <hr className="" />
                        <p className="" >

                            {t("extendable")}
                        </p>

                    </div>

                    <div className="flex justify-center ">
                        <button className="p-3 text-sm font-medium text-white bg-green-400 rounded-lg w-52"
                            onClick={() => navigator('/addOrder/price_personal')}
                        >{t("selection")} </button>
                    </div>
                </div>
            </Card>
        </>
    )


}


export default PersonalOrder;